import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Lucide from "lucide-react";
import { SERVICES } from "@/lib/site-data";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { FAQSection, FinalCTA } from "@/components/Sections";

export default function ServicesPage() {
  return (
    <main className="pt-32 sm:pt-36 pb-10 overflow-hidden" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#9db1ff]">Services</p>
          <h1 className="mt-4 font-heading text-5xl md:text-6xl font-bold text-white tracking-tighter leading-[1.05]">
            Every service you need to <span className="text-gradient-electric">land a US offer.</span>
          </h1>
          <p className="mt-5 text-zinc-400 text-lg leading-relaxed">
            Twelve focused services covering consultation, AI optimization, interview preparation and end-to-end placement. Pick one or get the full system.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Lucide[s.icon] || Lucide.Sparkles;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.04 }}
                className="glass-prism p-7 md:p-8"
                data-testid={`services-item-${i}`}
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="w-11 h-11 rounded-xl bg-[#2B4DFF]/15 border border-[#2B4DFF]/30 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#9db1ff]" />
                  </div>
                  <span className="font-mono text-xs text-zinc-500">0{i + 1 < 10 ? i + 1 : i + 1}</span>
                </div>
                <h2 className="font-heading text-2xl text-white">{s.title}</h2>
                <p className="mt-2 text-zinc-400 text-sm leading-relaxed">{s.desc}</p>
                <ul className="mt-5 space-y-2 text-sm text-zinc-300">
                  {["Personalized strategy", "Expert-led delivery", "Measurable outcomes"].map((b) => (
                    <li key={b} className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 h-4 text-emerald-400" /> {b}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm text-[#9db1ff] hover:text-white"
                >
                  Get started <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>

      <FAQSection />
      <FinalCTA />
    </main>
  );
}
